export const TABS_HORIZONTAL_PADDING = 2.4;
